import React from "react";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import FreelancerCard from "../marketplaceCategory/FreelancerCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {AiOutlineRight,AiOutlineLeft} from "react-icons/ai";


export default function Recommended() {
  const sliderRef = React.useRef();
  return (
    <Box border="1px solid gray" borderRadius={10} my={8}>
      <Flex bg="gray.100" justifyContent="space-between" p={8} fontWeight={500}>
        <Text fontSize="22px">Recommended For You</Text>
      </Flex>
      <Box p={{ base: 6, md: 8, xl: 10 }} pos="relative">
        {/* Padding is placed like this due to swiper arrow issue. They are not much customizeable */}
        <Swiper
        ref={sliderRef}
          slidesPerView={2}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            "@0.00": {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            600: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
          }}
          loop={true}
          className="mySwiper recommendation-slider"
          modules={[Navigation]}
          navigation={true}
          
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <FreelancerCard
                title={item.title}
                description={item.description}
                coverImageUrl={item.coverImageUrl}
                profileImageUrl={item.profileImageUrl}
                verified={item.verified}
                online={item.online}
                price={item.price}
                level={item.level}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <IconButton pos="absolute" top="50%" left="-5" rounded="full" bg="white" shadow="md" onClick={()=>{sliderRef.current.children[1].click();}}>
          <AiOutlineLeft />
        </IconButton>
        <IconButton pos="absolute" top="50%" right="-5" rounded="full" bg="white" shadow="md" onClick={()=>{sliderRef.current.children[2].click();}}>
          <AiOutlineRight />
        </IconButton>
      </Box>
    </Box>
  );
}
const data = [
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
    level: 2,
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
    level: 1,
  },
  {
    title: "Tim Josh",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
    level: 2,
  },
  {
    title: "Tim Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
    level: 1,
  },
];
